import { z } from "zod";

export const knownErrorCodeSchema = z.enum(["OccurrenceFinished"]);
type KnownErrorCode = z.infer<typeof knownErrorCodeSchema>;

const internalErrorCodeSchema = z.object({
  data: z.object({
    code: knownErrorCodeSchema,
  }),
});

export const isErrorWithKnownErrorCode = (
  error: unknown,
): error is { data: { code: KnownErrorCode } } => {
  return internalErrorCodeSchema.safeParse(error).success;
};

const internalErrorStatusSchema = z.object({
  response: z.object({
    status: z.number(),
  }),
});

const isErrorWithStatus = (
  error: unknown,
): error is { response: { status: number } } => {
  return internalErrorStatusSchema.safeParse(error).success;
};

export const isClientSideError = (error: unknown) => {
  return (
    isErrorWithStatus(error) &&
    error.response.status >= 400 &&
    error.response.status < 499
  );
};
